module.exports = __webpack_public_path__ + "static/media/user.930e5d5e.svg";